export default "__VITE_ASSET__CG3Rt$vq__"